const { IS_MOBILE: mobile } = TB_CONFIG_SITE_JS

export const IS_MOBILE = mobile === 1 || mobile === true ? true : false
